import { getVersion } from 'valtio';

const StateHelpers = {
    reset: <T>(state: T, defaults: T) => {
        if (defaults && getVersion(defaults)) {
            console.error('You are resetting a valtio proxy with a proxy!');
        }

        for (const key in defaults) {
            state[key as keyof T] = defaults[key as keyof T];
        }
    },
};

export { StateHelpers };
